import {Route, Routes} from 'react-router-dom';

import {List} from './List';

export default function DieuChinhHoaDonTrenHeThongKhac() {

  return (
    <Routes>
      <Route path="/" element={<List/>}/>
    </Routes>
  );
}
